var _rect, _path, _path2, _path3, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRighticon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 15,
    fill: "#64CB99"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.957 14.2105L11.8375 18.2517C12.6114 21.8034 12.9983 23.5793 14.1689 24.6435C14.2224 24.6921 14.2769 24.7395 14.3324 24.7854C15.546 25.7895 17.2062 25.7895 20.5264 25.7895H20.9852C23.8576 25.7895 25.2938 25.7895 26.4003 25.0273C26.679 24.8354 26.9379 24.6108 27.1725 24.3575M10.957 14.2105L10 10M10.957 14.2105H16.3636",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6125 28.9475C18.6125 29.5289 18.1841 30.0002 17.6556 30.0002C17.1271 30.0002 16.6987 29.5289 16.6987 28.9475C16.6987 28.3662 17.1271 27.8949 17.6556 27.8949C18.1841 27.8949 18.6125 28.3662 18.6125 28.9475Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3542 28.9475C24.3542 29.5289 23.9257 30.0002 23.3972 30.0002C22.8687 30.0002 22.4403 29.5289 22.4403 28.9475C22.4403 28.3662 22.8687 27.8949 23.3972 27.8949C23.9257 27.8949 24.3542 28.3662 24.3542 28.9475Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.0909,
    y: 10,
    width: 10.9091,
    height: 10.9091,
    rx: 1,
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRighticon2);
export default __webpack_public_path__ + "static/media/righticon2.88ab6c7fee07d34d8ab273ebff39e85c.svg";
export { ForwardRef as ReactComponent };